import React from "react";

export default function CompanionTurnReveal({ companionName, results, onContinue }) {
  const total = (results || []).reduce((sum, r) => sum + (r.score || 0), 0);

  return (
    <div className="flex flex-col items-center gap-4 py-10 px-4 text-center max-w-sm mx-auto">
      <div className="text-5xl" aria-hidden="true">🎉</div>
      <h2 className="text-xl font-extrabold text-yellow-200">{companionName} finished playing!</h2>
      <div className="bg-white rounded-2xl shadow-sm p-4 w-full">
        <p className="text-3xl font-extrabold text-[#7C3AED]">{total} pts</p>
        <p className="text-xs text-blue-600 mt-1">{companionName}'s total score</p>
      </div>
      <p className="text-sm text-white/80">Now it's YOUR turn — can you beat {companionName}? 💪</p>
      <button onClick={onContinue} className="w-full bg-[#7C3AED] text-white font-bold rounded-2xl py-3.5 text-base">
        Let's Go! →
      </button>
    </div>
  );
}